import Stack from "@mui/material/Stack";
import DataContainer from "../../../Utilities/DataContainer";
import RenderSelectField from "../../../Utilities/Forms/RenderSelectField";
import yesNoDropdown from "../../../Utilities/Constants/YesNoDropdown";
import useData from "../../../Utilities/Hooks/UseData";

const cashCardDropdown = [
    { id: '0', label: 'No' },
    { id: '1', label: 'Yes' },
];

const dropdown = [
    { id: 0, label: 'No' },
    { id: 1, label: 'Yes' },
];

interface IProps { isReadOnly: boolean; landuse: string; subuse: string; }

export default function RetailDetails({ isReadOnly, landuse, subuse }: IProps) {
    const { data: petrolDropdown } = useData('Site', `GetPfsDropdown?landuse=${landuse}&subuse=${subuse}`);

    return (
        <DataContainer title="Retail Details">
            <Stack spacing={1} >
                {
                    landuse === "01" && subuse === "A" &&
                    <>
                        <RenderSelectField label="Petrol Filling Station Included" name="retailDetails.petrolFillingStationIncluded" readOnly={isReadOnly} options={petrolDropdown} inputSize={12} />
                        <RenderSelectField label="Home Delivery Available" name="retailDetails.homeDeliveryAvailableStore" readOnly={isReadOnly} options={yesNoDropdown} />
                    </>
                }
                {
                    ((landuse === "01" && subuse !== "A") || (landuse === "07" && subuse === "B")) &&
                    <RenderSelectField label="Filling Station" name="retailDetails.petrolFillingStationAssociatedWithStore" readOnly={isReadOnly} options={dropdown} />
                }
                {
                    (landuse === "01" || (landuse === "07" && subuse === "B")) &&
                    <RenderSelectField label="Cash Card Facilities Available" name="retailDetails.cashCardFacilitiesAvailable" readOnly={isReadOnly} options={cashCardDropdown} />
                }
            </Stack >
        </DataContainer >
    );
}
